<template>
  <div>
    <slot />
  </div>
</template>

<script setup>
import { useGlobalStore } from "~/stores/global";

const globalStore = useGlobalStore();

// Keep the checkout flow out of search results via noindex. Do NOT block it with a
// robots.txt Disallow: `/*/checkout` also matches the shared /_nuxt/checkout.*.js
// chunks, which would stop Google fetching them and break hydration site-wide.
useHead({
  meta: [{ name: "robots", content: "noindex, nofollow" }],
});

addAnalytics(globalStore.siteSettings.google_analytics_4_id);
addGTMAnalytics(globalStore.siteSettings.google_tag_manager_id);
</script>
